import ReactMarkdown from "react-markdown";
import { CardImage } from "./CardImage";
import { useHistory } from "react-router";
import { useNavigate } from "react-router-dom";

function addImages(md: string) {
  const regex = /!\[[\w-]+\]\(([^)]+)\)/g;
  const matches = md.matchAll(regex);
  const asArray = Array.from(matches);

  for (const group of asArray) {
    const image = group[1];
    if (!image) {
      continue;
    }

    md = md.replaceAll(image, encodeURI(`/assets/resources/${image}`));
  }

  return md;
}
export function Markdown({ md }: { md: string }) {
  const navigate = useNavigate();

  return (
    <ReactMarkdown
      transformImageUri={(uri) => {
        return uri;
      }}
      components={{
        img: CardImage,
        em: (props) => <i>{props.children}</i>,
        a: (props) => {
          if (props.href?.startsWith("http")) {
            return (
              <a href={props.href} target="_blank" rel="noreferrer">
                {props.children}
              </a>
            );
          } else {
            const parts = props.href?.split("-");

            if (parts && parts[0] && parts[1]) {
              const href = `/cards/${parts[0]}/${parts[1]}`;
              return (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(href);
                  }}
                >
                  {props.children}
                </a>
              );
            } else {
              return <></>;
            }
          }
        },
      }}
    >
      {addImages(md)}
    </ReactMarkdown>
  );
}
